<template>
    <div>
        <Card>
            <Card>
                <p slot="title">{{t.user.searchName}}</p>
                <Form :model="formItem" :label-width="90" label-position="right">
                    <Row :gutter="16">
                        <Col span="6">
                            <Form-item :label="t.user.deptName">
                                <Input v-model.trim="formItem.deptName"
                                       :placeholder="msgUtil.placeholderRequired(t.user.deptName)"></Input>
                            </Form-item>
                        </Col>
                        <Col span="6">
                            <Form-item :label="t.user.loginName">
                                <Input v-model="formItem.loginName"
                                       :placeholder="msgUtil.placeholderRequired(t.user.loginName)"></Input>
                            </Form-item>
                        </Col>
                        <Col span="6">
                            <Form-item :label="t.user.name">
                                <Input v-model="formItem.name"
                                       :placeholder="msgUtil.placeholderRequired(t.user.name)"></Input>
                            </Form-item>
                        </Col>
                        <Col span="6">
                            <Form-item :label="t.user.type">
                                <Select v-model="formItem.type" clearable style="width: 100% !important"
                                        :placeholder="msgUtil.placeholderSelected(t.user.type)">
                                    <Option value="0">{{t.user.normalUser}}</Option>
                                    <Option value="1">{{t.user.members}}</Option>
                                    <Option value="2">{{t.user.systemUser}}</Option>
                                </Select>
                            </Form-item>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="6">
                            <Form-item :label="t.user.status">
                                <Select v-model="formItem.status" clearable style="width: 100% !important"
                                        :placeholder="msgUtil.placeholderRequired(t.user.status)">
                                    <Option value="1">{{t.user.open}}</Option>
                                    <Option value="0">{{t.user.close}}</Option>
                                </Select>
                            </Form-item>
                        </Col>
                        <Col span="6">
                            <Form-item :label="t.user.createStartTime">
                                <DatePicker type="datetime" format="yyyy/MM/dd HH:mm:ss"
                                            v-model="formItem.createStartTime" style="width: 100% !important"
                                            :placeholder="msgUtil.placeholderRequired(t.user.createStartTime)"
                                            :options="createStartTimeOption"
                                            @on-change="onCreateStartTimeChange"></DatePicker>
                            </Form-item>
                        </Col>
                        <Col span="6">
                            <Form-item :label="t.user.createEndTime">
                                <DatePicker type="datetime" format="yyyy/MM/dd HH:mm:ss"
                                            v-model="formItem.createEndTime"
                                            style="width: 100% !important"
                                            :placeholder="msgUtil.placeholderRequired(t.user.createEndTime)"
                                            :options="createEndTimeOption"
                                            @on-change="onCreateEndTimeChange"></DatePicker>
                            </Form-item>
                        </Col>
                        <Col span="6">
                            <Button type="primary" icon="ios-search" style="float: right;" @click="search(true)">
                                {{msgUtil.message.action.search}}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Card>
            <Row class="margin-top-10">
                <Col span="12">
                    <sort-button-group :buttons="sortButton" @on-order="orderClick"/>
                </Col>
                <Col style="text-align:right;" span="12">
                    <router-link to="./add">
                        <Button icon="md-add">{{msgUtil.message.action.add}}</Button>
                    </router-link>
                    <Button icon="ios-trash" @click="delAll">{{msgUtil.message.action.deleteAll}}</Button>
                </Col>
            </Row>
            <Row class="margin-top-10">
                <Table ref="selection" :context="self" :columns="columns" :data="data" :loading="loading"
                       @on-selection-change="rowSelect"></Table>
            </Row>
            <Row class="margin-top-10" type="flex" justify="end">
                <Page ref="page" :total="total" show-total show-sizer @on-change="pageChange"
                      @on-page-size-change="pageSizeChange">
                    {{msgUtil.message.page.total}} {{ total }} {{msgUtil.message.page.paper}}
                </Page>
            </Row>
        </Card>
    </div>
</template>
<script>
import { Message, Tag } from 'iview';
import store from '@/store';
import { del, delAll, getUserList } from '@/api/user';
import sortButtonGroup from '@/components/sort-button-group.vue';

export default {
    name: 'organization_user_list',
    components: {
        sortButtonGroup,
    },
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        const renderLoginName = (h, params) => {
            const row = params.row;
            return h('div', [
                h(
                    'router-link',
                    {
                        props: {
                            to: './detail/' + row.id,
                        },
                    },
                    row.loginName
                ),
            ]);
        };

        const renderType = (h, params) => {
            const row = params.row;
            let color = '';
            let text = '';
            if (row.type === '1') {
                color = 'warning';
                text = t.user.members;
            } else if (row.type === '2') {
                color = 'error';
                text = t.user.systemUser;
            } else {
                color = 'primary';
                text = t.user.normalUser;
            }
            return h(
                'Tag',
                {
                    props: {
                        type: 'border',
                        color: color,
                    },
                },
                text
            );
        };

        const renderStatus = (h, params) => {
            const row = params.row;
            const color = row.status === '0' ? 'error' : row.status === '1' ? 'success' : 'error';
            const text = row.status === '0' ? t.user.close : row.status === '1' ? t.user.open : t.user.close;
            return h(
                'Tag',
                {
                    props: {
                        type: 'border',
                        color: color,
                    },
                },
                text
            );
        };

        const renderAction = (h, params) => {
            const row = params.row;
            if(this.$store.state.user.myInfo.id === row.id){
                return h(
                );
            }else{
                return h('button-group', [
                    h(
                        'i-button',
                        {
                            props: {
                                type: 'primary',
                                size: 'small',
                                to: './edit/' + row.id,
                            },
                        },
                        msgUtil.message.action.edit
                    ),
                    h(
                        'i-button',
                        {
                            props: {
                                type: 'error',
                                size: 'small',
                                style: 'margin-left:5px',
                            },
                            on: {
                                click: this.del.bind(this, row.id),
                            },
                        },
                        msgUtil.message.action.delete
                    ),
                ]);
            }
        };
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            // 排序btn
            sortButton: [
                { key: 'deptName', value: t.sortButton.deptName, order: 0 },
                { key: 'name', value: t.sortButton.name, order: 0 },
                { key: 'type', value: t.sortButton.type, order: 0 },
                { key: 'createTime', value: t.sortButton.createTime, order: 0 },
            ],
            // 入力条件
            formItem: {
                deptName: '',
                loginName: '',
                name: '',
                type: '',
                status: '',
                createTime: '',
                createStartTime: null,
                createEndTime: null,
                oa: '',
                od: '',
                current: 1,
                size: 10,
            },
            createStartTimeOption: {},
            createEndTimeOption: {},
            selectIds: [],
            data: [],
            total: 0,
            // table定义列
            columns: [
                { title: '', type: 'selection', align: 'center', width: 44 },
                { title: t.table.id, key: 'id', align: 'center', width: 164 },
                { title: t.table.loginName, key: 'loginName', tooltip: true, render: renderLoginName },
                { title: t.table.deptName, key: 'deptName', tooltip: true },
                { title: t.table.name, key: 'name', tooltip: true },
                { title: t.table.mobile, key: 'mobile', tooltip: true },
                { title: t.table.createBy, width: 100, key: 'createBy', tooltip: true },
                { title: t.table.createTime, width: 150, key: 'createTime' },
                { title: t.table.type, key: 'type', align: 'center', width: 130, render: renderType },
                {
                    title: t.table.status,
                    key: 'status',
                    align: 'center',
                    width: 100,
                    render: renderStatus,
                },
                {
                    title: msgUtil.message.action.name,
                    key: 'action',
                    align: 'center',
                    width: 130,
                    fixed: 'right',
                    render: renderAction,
                },
            ],
            loading: false,
        };
    },
    methods: {
        //排序
        async orderClick(btn) {
            this.formItem.oa = '';
            this.formItem.od = '';
            if (btn.order === 1) {
                this.formItem.oa = btn.key;
            } else if (btn.order === 2) {
                this.formItem.od = btn.key;
            }
            await this.search(true);
        },
        //数据检索
        async search(flg) {
            if (flg) {
                this.formItem.current = 1;
                this.$refs.page.currentPage = 1;
            }
            this.loading = true;
            await this.getCreateTime();
            //console.log(this.formItem);
            const result = await getUserList(this.formItem);
            //console.log(result);
            if (result !== null) {
                this.data = result.page.records;
                this.total = result.page.total;
            }
            this.loading = false;
        }, // 页号改变
        async pageChange() {
            this.formItem.current = this.$refs.page.currentPage;
            await this.search(false);
        },
        // 每页显示数据
        async pageSizeChange() {
            this.formItem.size = this.$refs.page.currentPageSize;
            await this.search(false);
        },
        //创建时间作成
        async getCreateTime() {
            this.formItem.createTime = '';
            if (this.formItem.createStartTime !== '' && this.formItem.createStartTime !== undefined) {
                this.formItem.createTime = this.formItem.createStartTime + ',';
            }
            if (this.formItem.createEndTime !== '' && this.formItem.createEndTime !== undefined) {
                if (this.formItem.createStartTime === '' || this.formItem.createStartTime === undefined) {
                    this.formItem.createTime = ',';
                }
                this.formItem.createTime += this.formItem.createEndTime;
            }
        },
        // 删除
        async del(id) {
            await del(id);
            await this.search(true);
        },
        // 批量删除
        async delAll() {
            if (this.selectIds.length == 0) {
                Message.error({
                    content: this.msgUtil.message.warn.notSelectedRow,
                    duration: 60,
                    closable: true,
                });
                return;
            }
            await delAll(this.selectIds);
            await this.search(true);
        },
        // 行选择
        rowSelect(selection) {
            this.selectIds = selection.map(p => {
                return { id: p.id };
            });
        },
        onCreateStartTimeChange(startTime) {
            this.formItem.createStartTime = startTime;
            this.createEndTimeOption = {
                disabledDate(endTime) {
                    return endTime < new Date(startTime) || endTime > Date.now();
                },
            };
        },
        onCreateEndTimeChange(endTime) {
            this.formItem.createEndTime = endTime;
            this.createStartTimeOption = {
                disabledDate(startTime) {
                    return startTime > new Date(endTime) || startTime > Date.now();
                },
            };
        },
    },
    async mounted() {
        await this.search(true);
    },
};
</script>
<style>
</style>
